"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBackIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _rebrand = require("../../../../icons-react/rebrand");
var SIZES = {
  s: {
    width: 11,
    height: 12
  },
  m: {
    width: 12,
    height: 14
  },
  l: {
    width: 16,
    height: 20
  }
};
var CashBackIcon = exports.CashBackIcon = function CashBackIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_rebrand.Cashback, SIZES[size]);
};